import { classNames } from "primereact/utils";

import { positionStyle, resolveGanttLayout } from "./gantt-layout";
import styles from "./gantt.module.scss";
import type { LineMarkProps, LineMarkViewModel } from "./types-gantt";

/** ViewModel da `LineMark`: posição, classes e atributos da linha fina com o rótulo acima; sem JSX. */
export function useGanttLineMark({
  position,
  tone,
  label,
  lane = 0,
  layout,
  past,
  testId,
  className,
  style,
  classNames: parts,
  ...rest
}: LineMarkProps): LineMarkViewModel {
  const resolved = resolveGanttLayout(layout);

  return {
    className: classNames(styles.lineMark, className),
    labelClassName: classNames(styles.lineMarkLabel, parts?.label),
    ruleClassName: classNames(styles.lineMarkRule, parts?.rule),
    style: { ...positionStyle(resolved, position, lane), ...style },
    tone,
    dataPast: past || undefined,
    testId,
    label,
    rest,
  };
}
